export const I18N = {
  ru: {
    panel: 'Панель управления СЦ',
    capModules: 'Ведение данных (АРМ)',
    capAdmin: 'Администрирование',
    mGov: 'Госуслуги',
    mVideo: 'Видеопоток',
    mHealth: 'Здравоохранение',
    mBudget: 'Доходы и расходы (с накоплением и без)',
    mEdu: 'Образование',
    aUsers: 'Настройка пользователей',
    aRoles: 'Настройка ролей',
    aLog: 'Действия пользователей',
    title: 'Образование — дошкольные организации',
    create: 'Создать',
    reset: 'Сбросить',
    perPage: 'стр.',
    fSearch: 'Поиск',
    phSearch: 'Наименование или адрес',
    fLoc: 'Местность',
    fType: 'Вид ДДО',
    fState: 'Заполненность',
    allLoc: 'Все населённые пункты',
    allType: 'Все виды',
    allState: 'Любое состояние',
    colName: 'Наименование',
    colLoc: 'Местность',
    colType: 'Вид ДДО',
    colLang: 'Язык обучения',
    colForm: 'Форма учреждения',
    colSeats: 'Проектная мощность',
    colKont: 'Факт. наполненность',
    colState: 'Заполненность',
    colActive: 'Статус',
    stProf: 'Профицит',
    stNorm: 'Норма',
    stDefic: 'Дефицит',
    stND: '—',
    actOn: 'Активен',
    actOff: 'Не активен',
    found: 'Найдено записей: {n}',
    mTitle: 'Создание дошкольной организации',
    secGeneral: 'Сведения об организации',
    secClass: 'Классификация (разрезы дэшборда)',
    secCounts: 'Показатели наполненности и очереди',
    secMeta: 'Отчётность и учёт',
    fName: 'Наименование организации',
    fAddr: 'Адрес',
    fDistrict: 'Район',
    fCoords: 'Координаты (широта, долгота)',
    fForm: 'Форма учреждения',
    fTypeF: 'Вид ДДО',
    fLang: 'Язык обучения',
    fTime: 'Продолжительность нахождения',
    fSeats: 'Проектная мощность',
    fKont: 'Фактическая наполненность',
    fFree: 'Свободные места',
    fQueue: 'В очереди',
    fNapr: 'Выдано направлений',
    fZach: 'Зачислено',
    fPeriod: 'Отчётный период',
    fActive: 'Статус активности',
    phName: 'Полное наименование дошкольной организации',
    phAddr: 'Адрес дошкольной организации',
    phLat: 'широта',
    phLon: 'долгота',
    phSeats: 'мест',
    phKont: 'детей',
    hintCoords:
      'Необязательно. Формат до 6 знаков после запятой. Используется для отображения на карте основной части.',
    hintLang: '«Смешанный» — обучение ведётся на казахском и русском языках.',
    hintActive: '«Не активен» — организация не учитывается при построении дэшборда.',
    optional: 'Необязательное поле.',
    selPlaceholder: '— выберите —',
    calcDev: 'Отклонение (мощность − факт):',
    calcState: 'Состояние наполненности:',
    calcHint: 'Рассчитывается ПО автоматически при сохранении и не вводится вручную.',
    footNote: 'Поля со звёздочкой (*) обязательны.',
    cancel: 'Отмена',
    save: 'Сохранить',
    reqMsg: 'Поле обязательно для заполнения',
    numMsg: 'Допускается только целое неотрицательное число',
    numMsgCoords: 'Координаты указываются числом (до 6 знаков после разделителя)',
    alertReq: 'Заполните обязательные поля, выделенные красным.',
    toastOk: 'Дошкольная организация «{n}» сохранена',
    toastSub: 'Запись добавлена в перечень и в журнал действий пользователей.',
    alertServer: 'Не удалось сохранить: ошибка сервера. Повторите попытку.',
    emptyList: 'Нет записей, удовлетворяющих условиям поиска',
  },
  kk: {
    panel: 'СО басқару панелі',
    capModules: 'Деректерді енгізу (АЖО)',
    capAdmin: 'Әкімшілендіру',
    mGov: 'Мемлекеттік қызметтер',
    mVideo: 'Бейнеағын',
    mHealth: 'Денсаулық сақтау',
    mBudget: 'Кірістер мен шығыстар',
    mEdu: 'Білім беру',
    aUsers: 'Пайдаланушыларды баптау',
    aRoles: 'Рөлдерді баптау',
    aLog: 'Пайдаланушы әрекеттері',
    title: 'Білім беру — мектепке дейінгі ұйымдар',
    subtitle:
      'Автоматтандырылған жұмыс орны · мектепке дейінгі ұйымдар туралы мәліметтерді жүргізу',
    create: 'Құру',
    perPage: 'бет',
    infoNote:
      'Енгізілген жазбалар БҚ дерекқорында сақталады және БҚ негізгі бөлігінде («Білім беру» модулі) қолжетімді болады: «Балаларды балабақшаларға бөлу» дэшбордында, картада, диаграммаларда және жиынтық кестеде. Тізбені жүргізу әрекеттері пайдаланушы әрекеттерінің журналында тіркеледі.',
    fSearch: 'Іздеу',
    phSearch: 'Атауы немесе мекенжайы',
    fLoc: 'Елді мекен',
    fType: 'МДҰ түрі',
    fState: 'Толымдылық',
    reset: 'Тазалау',
    allLoc: 'Барлық елді мекен',
    allType: 'Барлық түрлер',
    allState: 'Кез келген күй',
    colName: 'Атауы',
    colLoc: 'Елді мекен',
    colType: 'МДҰ түрі',
    colLang: 'Оқыту тілі',
    colForm: 'Мекеме нысаны',
    colSeats: 'Жобалық қуат',
    colKont: 'Нақты толымдылық',
    colState: 'Толымдылық',
    colActive: 'Күйі',
    stProf: 'Профицит',
    stNorm: 'Норма',
    stDefic: 'Тапшылық',
    stND: '—',
    actOn: 'Белсенді',
    actOff: 'Белсенді емес',
    found: 'Табылған жазбалар: {n}',
    mTitle: 'Мектепке дейінгі ұйымды құру',
    secGeneral: 'Ұйым туралы мәліметтер',
    secClass: 'Жіктеу (дэшборд қималары)',
    secCounts: 'Толымдылық және кезек көрсеткіштері',
    secMeta: 'Есептілік және есеп',
    fName: 'Ұйым атауы',
    fAddr: 'Мекенжайы',
    fDistrict: 'Аудан',
    fCoords: 'Координаттар (ендік, бойлық)',
    fForm: 'Мекеме нысаны',
    fTypeF: 'МДҰ түрі',
    fLang: 'Оқыту тілі',
    fTime: 'Болу ұзақтығы',
    fSeats: 'Жобалық қуат',
    fKont: 'Нақты толымдылық',
    fFree: 'Бос орындар',
    fQueue: 'Кезекте',
    fNapr: 'Берілген жолдамалар',
    fZach: 'Қабылданған',
    fPeriod: 'Есепті кезең',
    fActive: 'Белсенділік күйі',
    phName: 'Мектепке дейінгі ұйымның толық атауы',
    phAddr: 'Мектепке дейінгі ұйымның мекенжайы',
    phLat: 'ендік',
    phLon: 'бойлық',
    phSeats: 'орын',
    phKont: 'бала',
    hintCoords:
      'Міндетті емес. Ондық бөлгіштен кейін 6 таңбаға дейін. Негізгі бөліктің картасында көрсету үшін пайдаланылады.',
    hintLang: '«Аралас» — оқыту қазақ және орыс тілдерінде жүргізіледі.',
    hintActive: '«Белсенді емес» — ұйым дэшборд құру кезінде есепке алынбайды.',
    optional: 'Міндетті емес өріс.',
    selPlaceholder: '— таңдаңыз —',
    calcDev: 'Ауытқу (қуат − нақты):',
    calcState: 'Толымдылық күйі:',
    calcHint: 'Сақтау кезінде БҚ автоматты есептейді, қолмен енгізілмейді.',
    footNote: 'Жұлдызшамен (*) белгіленген өрістер міндетті.',
    cancel: 'Болдырмау',
    save: 'Сақтау',
    reqMsg: 'Өрісті толтыру міндетті',
    numMsg: 'Тек бүтін теріс емес сан рұқсат етіледі',
    numMsgCoords: 'Координаттар сан түрінде көрсетіледі (бөлгіштен кейін 6 таңбаға дейін)',
    alertReq: 'Қызылмен белгіленген міндетті өрістерді толтырыңыз.',
    toastOk: '«{n}» мектепке дейінгі ұйымы сақталды',
    toastSub: 'Жазба тізбеге және пайдаланушы әрекеттерінің журналына қосылды.',
    alertServer: 'Сақтау мүмкін болмады: сервер қатесі. Қайталап көріңіз.',
    emptyList: 'Іздеу шарттарына сай жазбалар жоқ',
  },
};

/** t(lang, key) → строка. {n}-подстановка делается на месте вызова (.replace('{n}', x)). */
export function t(lang, key) {
  const dict = I18N[lang] || I18N.ru;
  const val = dict[key];
  return val != null ? val : I18N.ru[key] != null ? I18N.ru[key] : key;
}

/** Диагностика: список ключей, которых нет в одном из языков (в dev — вывести в консоль). */
export function i18nParityDiff() {
  const ruKeys = Object.keys(I18N.ru);
  const kkKeys = Object.keys(I18N.kk);
  const missingInKk = ruKeys.filter((k) => !(k in I18N.kk));
  const missingInRu = kkKeys.filter((k) => !(k in I18N.ru));
  return { missingInKk, missingInRu };
}
